import { DropdownModule } from 'primeng/dropdown';

import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { AppDirectivesModule } from '../_directives/app-directives.module';


import { SharedModule } from 'src/app/_theme/components/shared.module';

@NgModule({
  declarations: [
     LoginComponent 
    ],
  exports: [ 
    LoginComponent
   ],
  imports: [
    TranslateModule,
    CommonModule,
    ReactiveFormsModule,
    AppDirectivesModule,
    DropdownModule,
    SharedModule,

  ]
})
export class LoginModule { }
